// import routeKeys from '../routes/keys';

export default {
  copyright: '© MARINA BORS'
  // links: [
  //   {
  //     text: 'Home',
  //     path: '/'
  //   },
  //   {
  //     text: 'About',
  //     path: routeKeys.About
  //   }
  // ]
};
